import {
  ConsultaSeguimentoPergunta03ExemplosEnum,
  ConsultaSeguimentoPergunta03Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-03/model-consultaSeguimentoPergunta03'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS, splitHeaderAndPerguntas } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta03Model {
  header: MchatRfAplicacaoQueryModel
  perguntas: MchatRfAplicacaoQueryModel[]
  model: ConsultaSeguimentoPergunta03Model
}

export const convertAplicacaoPergunta03 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta03Model | null => {
  const { header, perguntas } = splitHeaderAndPerguntas(aplicacoes, MChatPerguntaEnum.PERGUNTA_03_01)
  if (header === undefined || perguntas === null || perguntas.length === 0) return null

  return {
    header,
    perguntas,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_03_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_03_EXEMPLOS: convertAplicacoesToExemplos(perguntas),
      OUTRO: convertAplicacaoToOutro(
        perguntas.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_03_12)
      ),
    },
  }
}

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta03ExemplosEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta03ExemplosEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

const convertAplicacaoToOutro = (
  aplicacao: MchatRfAplicacaoQueryModel | undefined
): ConsultaSeguimentoPergunta03Model['OUTRO'] => ({
  radioValue: booleanToSimNaoEnum(aplicacao?.stPassou),
  textValue: aplicacao?.outros ?? undefined,
})

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta03ExemplosEnum, undefined> = {
  [ConsultaSeguimentoPergunta03ExemplosEnum.BEBIA_XICARA_BRINQUEDO]: undefined,
  [ConsultaSeguimentoPergunta03ExemplosEnum.COMIA_COLHER_BRINQUEDO]: undefined,
  [ConsultaSeguimentoPergunta03ExemplosEnum.FALAVA_TELEFONE]: undefined,
  [ConsultaSeguimentoPergunta03ExemplosEnum.DAVA_COMIDA]: undefined,
  [ConsultaSeguimentoPergunta03ExemplosEnum.EMPURRAR_CARRO]: undefined,
  [ConsultaSeguimentoPergunta03ExemplosEnum.PERSONAGENS_FAVORITOS]: undefined,
  [ConsultaSeguimentoPergunta03ExemplosEnum.PANELA_FOGAO]: undefined,
  [ConsultaSeguimentoPergunta03ExemplosEnum.MEXEU_COMIDA]: undefined,
  [ConsultaSeguimentoPergunta03ExemplosEnum.MOTORISTA_PASSAGEIRO]: undefined,
  [ConsultaSeguimentoPergunta03ExemplosEnum.ASPIRAVA_VARRIA_CORTAVA]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta03ExemplosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_03_02]: ConsultaSeguimentoPergunta03ExemplosEnum.BEBIA_XICARA_BRINQUEDO,
  [MChatPerguntaEnum.PERGUNTA_03_03]: ConsultaSeguimentoPergunta03ExemplosEnum.COMIA_COLHER_BRINQUEDO,
  [MChatPerguntaEnum.PERGUNTA_03_04]: ConsultaSeguimentoPergunta03ExemplosEnum.FALAVA_TELEFONE,
  [MChatPerguntaEnum.PERGUNTA_03_05]: ConsultaSeguimentoPergunta03ExemplosEnum.DAVA_COMIDA,
  [MChatPerguntaEnum.PERGUNTA_03_06]: ConsultaSeguimentoPergunta03ExemplosEnum.EMPURRAR_CARRO,
  [MChatPerguntaEnum.PERGUNTA_03_07]: ConsultaSeguimentoPergunta03ExemplosEnum.PERSONAGENS_FAVORITOS,
  [MChatPerguntaEnum.PERGUNTA_03_08]: ConsultaSeguimentoPergunta03ExemplosEnum.PANELA_FOGAO,
  [MChatPerguntaEnum.PERGUNTA_03_09]: ConsultaSeguimentoPergunta03ExemplosEnum.MEXEU_COMIDA,
  [MChatPerguntaEnum.PERGUNTA_03_10]: ConsultaSeguimentoPergunta03ExemplosEnum.MOTORISTA_PASSAGEIRO,
  [MChatPerguntaEnum.PERGUNTA_03_11]: ConsultaSeguimentoPergunta03ExemplosEnum.ASPIRAVA_VARRIA_CORTAVA,
}
